export const SET_I18N = 'common/SET_I18N';
export const SET_IS_BILLING_LIVE = 'common/SET_IS_BILLING_LIVE';
export const SET_IS_APP_LOADING = 'common/SET_IS_APP_LOADING';
export const SET_SNACK_MESSAGE = 'common/SET_SNACK_MESSAGE';
export const CLEAR_SNACK_MESSAGE = 'common/CLEAR_SNACK_MESSAGE';
export const SET_IS_DEMO_MODE = 'common/SET_IS_DEMO_MODE';
export const SET_LOADING_MODULE = 'common/SET_LOADING_MODULE';
export const SET_AUTH_STATE_LOADING = 'common/SET_AUTH_STATE_LOADING';
